import { useCallback, useState } from 'react';

// Which cards and rows of the side panels (and other folds) the user has opened or closed, remembered in this browser, so they stay
// as they were chosen when another object is chosen, another page is visited or the page is loaded again. An id is a card's title
// (card:Hvad er det) or a row's name; what has not been touched opens as the card is built to ("Hvad er det" and the card with the problem).
const KEY = 'nc-panel-open';
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch { return {}; } };
const write = (all) => { try { localStorage.setItem(KEY, JSON.stringify(all)); } catch { /* not remembered */ } };

export function usePanelOpen() {
  const [store, setStore] = useState(read);
  // "Udvid alle" is a mode, not a one-off: while it is on, every card opens (in every category and for every object) unless the
  // user has closed that card on purpose afterwards.
  const isOpen = useCallback((id, fallback) => (id in store ? !!store[id] : store.__all ? true : !!fallback), [store]);
  const setAll = useCallback((ids, value) => setStore((prev) => {
    const next = Object.fromEntries(Object.entries(prev).filter(([k]) => !k.startsWith('card:')));
    next.__all = !!value;
    if (!value) ids.forEach((id) => { next[id] = false; });
    write(next);
    return next;
  }), []);
  const setMany = useCallback((ids, value) => setStore((prev) => {
    const next = { ...prev };
    ids.forEach((id) => { next[id] = !!value; });
    write(next);
    return next;
  }), []);
  const toggle = useCallback((id, current) => setMany([id], !current), [setMany]);
  return { isOpen, toggle, setMany, setAll };
}
